import { useQuery } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';

import { useArticleAddNewAlias } from '@/module/Author/Article/model/ArticleQuery';
import { PublicationNewAliasRequest } from '@/module/Author/Publication/model/PublicationTypes';
import { articleMembershipOptions } from '@/module/Nomen/ArticleMembership/model/ArticleMembershipModel';

import { Id, useAppNotification } from '@feature/utils';

import { PublicationSearchClaimable } from '../Publication/PublicationSearchClaimable';

export function ArticleSearchClaimable() {
  const notification = useAppNotification();
  const navigate = useNavigate();

  const { data: memberships, isLoading, isError } = useQuery(articleMembershipOptions.getAll());

  const mutation = useArticleAddNewAlias();
  const onAddNewAlias = (publicationId: Id, request: PublicationNewAliasRequest) =>
    mutation.mutate(
      { articleId: publicationId, request: request },
      {
        onSuccess: article => {
          notification.success();
          navigate({ to: '/author/article/$articleId', params: { articleId: String(article.id) } });
        },
        onError: notification.error,
      },
    );

  return (
    <PublicationSearchClaimable
      memberships={memberships}
      membershipsLoading={isLoading}
      membershipsError={isError}
      onAddNewAlias={onAddNewAlias}
    />
  );
}
